module.exports = "/packs/images/pages/gift_cards/gift-card-redeem~37f7e624368cf6fc483112506369d5b3.png";